<template>
  <li>
    <span>ARTISTS</span>
    <div class="header_hover_menu">
      <router-link to="/apply">APPLY</router-link>
      <!-- <router-link to="/drops" class="font-lg w-100">{{ $t("menu.marketPlace") }}</router-link> -->
      <!-- <span class="text-gray font-lg w-100" id="digital-frame-info">{{ $t("menu.digitalFrame") }}</span> -->
    </div>
  </li>
</template>

<script>
export default {
  name: "HeaderDropDownArtists",
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
